import { render, staticRenderFns } from "./ServiceScheduleTutorSuccessfulAction.vue?vue&type=template&id=894ac2ec&"
import script from "./ServiceScheduleTutorSuccessfulAction.vue?vue&type=script&lang=js&"
export * from "./ServiceScheduleTutorSuccessfulAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports